module.exports = __webpack_public_path__ + "static/media/和分销.8c3e1147.png";